import { render, staticRenderFns } from "./abstract-edit.vue?vue&type=template&id=74aaf1be&scoped=true"
import script from "./abstract-edit.vue?vue&type=script&lang=js"
export * from "./abstract-edit.vue?vue&type=script&lang=js"
import style0 from "./abstract-edit.vue?vue&type=style&index=0&id=74aaf1be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aaf1be",
  null
  
)

export default component.exports